// VSB free demo (snippets/vsb-free-demo-panel, sections/vsb-free-demo): a page
// opened at #free-demo, or a link to it followed on the page, ends with the demo
// at the top, just under whatever bars stay pinned there (the store header, the
// sale bar with its timer: their heights differ by page and by screen, so they
// are measured, not guessed). The browser jumps there at once, but the lazy
// sections above (content-visibility) and their pictures draw afterwards and
// change height, so the jump lands short or long. Settle it again until it holds
// still, for at most three seconds, and stop the moment the visitor scrolls,
// swipes, clicks or presses a key.
(() => {
  if (window.vsbFreeDemo) return;
  window.vsbFreeDemo = true;
  const ID = 'free-demo';
  const GAP = 16;
  // The bottom of the bars pinned to the top of the screen right now.
  const pinned = () => {
    let bottom = 0;
    for (const e of document.querySelectorAll('header, [class*="header"], [class*="announcement"], [class*="bar"], [class*="sticky"], d-sticky, sticky-header')) {
      const s = getComputedStyle(e);
      if ((s.position !== 'fixed' && s.position !== 'sticky') || s.display === 'none' || s.visibility === 'hidden') continue;
      const r = e.getBoundingClientRect();
      if (r.height === 0 || r.top > 1 || r.bottom <= 0 || r.height > innerHeight * 0.4) continue;
      bottom = Math.max(bottom, r.bottom);
    }
    return bottom;
  };
  const settle = () => {
    const el = document.getElementById(ID);
    if (!el) return;
    let stop = false;
    const quit = () => { stop = true; };
    ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach((t) => addEventListener(t, quit, { once: true, passive: true }));
    const until = performance.now() + 3000;
    let still = 0;
    let frame = 0;
    let top = pinned() + GAP;
    const step = () => {
      if (stop || performance.now() > until) return;
      if (++frame % 6 === 0) top = pinned() + GAP;
      const off = el.getBoundingClientRect().top - top;
      if (Math.abs(off) > 2) { scrollBy(0, off); still = 0; } else if (++still > 20) return;
      requestAnimationFrame(step);
    };
    el.scrollIntoView({ block: 'start' });
    requestAnimationFrame(step);
  };
  const wanted = () => location.hash === `#${ID}`;
  if (wanted()) {
    if (document.readyState === 'complete') settle(); else addEventListener('load', settle, { once: true });
  }
  addEventListener('hashchange', () => { if (wanted()) settle(); });
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest(`a[href$="#${ID}"]`);
    if (!a || a.pathname !== location.pathname || a.host !== location.host) return;
    e.preventDefault();
    history.pushState(null, '', `#${ID}`);
    settle();
  });
})();
